/**
 * Custom Theme JavaScript
 */

// Product Addon Alternate Modal JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Open modal
  document.querySelectorAll('[data-modal-trigger]').forEach(function(button) {
    button.addEventListener('click', function() {
      var modalId = this.getAttribute('data-modal-trigger');
      var modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });
  
  // Close modal
  document.querySelectorAll('[data-modal-close]').forEach(function(button) {
    button.addEventListener('click', function() {
      var modalId = this.getAttribute('data-modal-close');
      var modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });
  
  // Close modal when clicking outside
  document.querySelectorAll('.product-addon-modal').forEach(function(modal) {
    modal.addEventListener('click', function(e) {
      if (e.target === this) {
        this.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });
  
  // Close modal with ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.product-addon-modal.active').forEach(function(modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      });
    }
  });
});
